import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";

class ProfileProductProxiesTextArea extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    proxies: [],
    busy: false,
    editSubnetId: 0,
    proxiesList: "",
  };

  componentDidMount() {
    let product = this.props.edit;
    if (product.proxies === null || product.proxies === undefined) {
      product.proxies = [];
    }

    let subnets = product.proxies;
    let proxiesList = [];

    subnets.map(async (subnet) => {
      if (subnet.proxies === undefined) {
        subnet.proxies = [];
      }

      subnet.proxies.map((proxy, index) => {
        if (proxy.slug === undefined) {
          subnet.proxies[index] = {
            slug: proxy,
            name: proxy,
          };
          proxiesList.push(proxy);
        } else {
          proxiesList.push(proxy.name);
        }

        product.proxiesList = proxiesList.join().replace(/,/g, "\n");
        this.props.initialize(product);
        return proxy;
      });

      return await subnet;
    });

    this.setState(product, () => {
      this.props.handleForm(this.state);
    });
  }

  filterSubnets = (event) => {
    let filteredSubnets = this.props.subnets.filter(
      (obj) => event.value === obj.geo_maxmind
    );

    let subnets = [];
    filteredSubnets.forEach((subnet) => {
      subnets.push({
        slug: subnet.sid,
        name: subnet.subnet,
      });
    });

    this.setState({ subnet_suggestions: subnets, subnets: [] });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value.replace(/\n/g, ",");

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">
            {this.state.status === "active" ? "Update Proxies" : "Proxies"} -
            {this.state.name}
          </h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          <Field
            component="textarea"
            type="textarea"
            name="proxiesList"
            onChange={this.formChangeHandler}
          />
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "update_proxies_textarea_form", // a unique identifier for this form
})(ProfileProductProxiesTextArea);
